<template>
    <div class="popup">
        <div class="popup-wrap">
            <div class="popup-bg" @click="closePopup()"></div>
            <div class="popup-container">
                <div class="popup-top">
                    <div class="popup-top__title">
                        {{ title }}
                    </div>
                    <button class="popup-close" @click="closePopup()">
                        <svg aria-hidden="true" width="25" height="25" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
                    </button>
                </div>
                <div class="popup-content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'popup-wrap',
        props: ['title'],
        methods: {
            closePopup(){
                this.$emit('close-popup');
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/scss/vars";
    .popup{
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 50;
        overflow-y: auto;
        &-bg{
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0,0,0,.5);
        }
        &-wrap{
            width: 100%;
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            z-index: 10;
            overflow-y: auto;
        }
        &-container{
            margin-top: 50px;
            margin-bottom: 50px;
            width: 100%;
            max-width: 840px;
            background: #fff;
            padding: 25px 35px;
            position: relative;
            z-index: 2;
        }
        &-content{

        }
        &-top{
            width: 100%;
            padding-bottom: 15px;
            border-bottom: solid 1px #dadada;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            &__title{
                width: 100%;
                max-width: 90%;
                text-transform: uppercase;
                font: $ttb;
                font-size: 18px;
                line-height: 24px;
            }
        }

        &-close{
            padding: 0;
            width: 20px;
            height: 20px;
            svg{
                width: 20px;
                height: 20px;
                color: #9a9a9a;
            }
        }
    }
    @media screen and (max-width: 900px){
        .popup-bg{
            position: fixed;
        }
        .popup-wrap{
            height: 100vh;
            padding-left: 15px;
            padding-right: 15px;
            display: block;
        }
        .popup-wrap{
            overflow-y: auto;
        }
    }
    @media screen and (max-width: 425px){
        .popup-container{
            padding: 15px 20px;
        }
        .popup-top__title{
            font-size: 16px;
        }
        .popup-top{
            padding-bottom: 10px;
        }
    }
</style>

